/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentGeometryGeometriesInnerOneOf1
 */
export interface EquipmentGeometryGeometriesInnerOneOf1 {
    /**
     * 
     * @type {EquipmentGeometryGeometriesInnerOneOf1TypeEnum}
     * @memberof EquipmentGeometryGeometriesInnerOneOf1
     */
    type: EquipmentGeometryGeometriesInnerOneOf1TypeEnum;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof EquipmentGeometryGeometriesInnerOneOf1
     */
    coordinates: Array<Array<number>>;
}


/**
 * @export
 */
export const EquipmentGeometryGeometriesInnerOneOf1TypeEnum = {
    LineString: 'LineString'
} as const;
export type EquipmentGeometryGeometriesInnerOneOf1TypeEnum = typeof EquipmentGeometryGeometriesInnerOneOf1TypeEnum[keyof typeof EquipmentGeometryGeometriesInnerOneOf1TypeEnum];


/**
 * Check if a given object implements the EquipmentGeometryGeometriesInnerOneOf1 interface.
 */
export function instanceOfEquipmentGeometryGeometriesInnerOneOf1(value: object): value is EquipmentGeometryGeometriesInnerOneOf1 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'LineString') return false;
    
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function EquipmentGeometryGeometriesInnerOneOf1FromJSON(json: any): EquipmentGeometryGeometriesInnerOneOf1 {
    return EquipmentGeometryGeometriesInnerOneOf1FromJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentGeometryGeometriesInnerOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function EquipmentGeometryGeometriesInnerOneOf1ToJSON(json: any): EquipmentGeometryGeometriesInnerOneOf1 {
    return EquipmentGeometryGeometriesInnerOneOf1ToJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf1ToJSONTyped(value?: EquipmentGeometryGeometriesInnerOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

